const useScrollTo = () => {
  const scrollToTop = () => {
    const empDivContainer = document.getElementById('emp');
    empDivContainer?.scrollTo(0, 0);
  };

  return {
    scrollToTop,
  };
};

export default useScrollTo;
